<div class="main">
    <div class="header">
      {{ 'CREATE_BILLS.invoice_history' | translate}}
      <i class="material-icons" (click)="closeModal();">clear</i>
    </div>
    <div class="section">
        <div class="table">
            <table *ngIf="history_data.length; else noInvoices" mat-table [dataSource]="history_data">
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="customHeader">{{'INVOICE_HISTORY.status' | translate}} </th>
                <td mat-cell *matCellDef="let element" class="status"> 
                    <div [ngClass]="{'approved': element.status == 'APPROVED','disapproved': element.status == 'DISAPPROVED','pending': element.status == 'PENDING','billed': element.status == 'BILLED' }">
                      {{element.status}}
                    </div> 
                </td>
              </ng-container>
                <!-- <ng-container matColumnDef="version">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'INVOICE_HISTORY.version' | translate}} </th>
                  <td mat-cell *matCellDef="let element" >
                    {{ element.version }}
                  </td>
                </ng-container>
     -->
                <ng-container matColumnDef="updated_by">
                  <th mat-header-cell *matHeaderCellDef class="customHeader">{{'INVOICE_HISTORY.updated_by' | translate}}</th>
                  <td mat-cell *matCellDef="let element"> 
                    {{ element.updated_by }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="datetime">
                  <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'INVOICE_HISTORY.time' | translate}} </th>
                  <td mat-cell *matCellDef="let element" >
                    {{ element.datetime }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="comment">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">{{'INVOICE_HISTORY.comment' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> 
                      {{ element.comment }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef class="customHeader">{{'INVOICE_HISTORY.view' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> 
                        <div [ngClass]="{'approved-view': element.status == 'APPROVED','disapproved-view': element.status == 'DISAPPROVED','pending-view': element.status == 'PENDING','billed-view': element.status == 'BILLED'}">
                           <a href="{{ element.pdf_link }}" style="color: white; text-decoration: none;">{{ element.view }}</a>
                        </div>
                    </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayColumns;" style="font-weight: bold !important;"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
              </table>
        </div>
        <ng-template #noInvoices>
          <div class="noInvoices">
                  {{'CREATE_BILLS.no_invoices_found' | translate}}
          </div>
          </ng-template>
    </div>
  </div>